import { registerComponent } from "lib/components";
import { RoleDescriptionViewerApp } from "./main";

registerComponent({ RoleDescriptionViewerApp });
